import { numberToTime, unixToTime } from "../../../../utils/date";

export function getFlightTime(event, enableTrackFlight = true) {
  let flightTime;

  if (enableTrackFlight && event) {
    const { weightAndBalance, finishTime, startTime } = event;

    const weightAndBalanceObject = weightAndBalance ? JSON.parse(weightAndBalance) : {};

    if (typeof weightAndBalanceObject === 'object' && weightAndBalanceObject !== null) {
      flightTime = numberToTime(weightAndBalanceObject.eventDuration);
    } else {
      flightTime = unixToTime((finishTime - startTime) * 1000);
    }

    return flightTime;
  }
}
